import { axiosInstance } from "./axiosInstance";

const getMatchList = ({ page,
    per_page = 1,
    delay = 1,
    search }) => axiosInstance.get(`/confirmed-matches`, {
        params: {
            page,
            per_page,
            delay,
            search
        }
    }).then(res => res?.data)
const getLimitationMatchList = ({ page,
    per_page = 1,
    delay = 1,
    search }) => axiosInstance.get(`/match-limitation`, {
        params: {
            page,
            per_page,
            delay,
            search
        }
    }).then(res => res?.data)
const updateMatchLimitation = (data) => axiosInstance.post(`match-limitation/update`, data, {
    headers: {
        "Content-Type": "multipart/form-data"
    }
})
const getMatchLimitDetails = (matchLimitId) => axiosInstance.get(`match-limitation/${matchLimitId}/`).then(res => res?.data)
const exportMatches = (data) => axiosInstance.get(`match-export`, data, {
    headers: {
        "Content-Type": "application/json",

    }
})

export { getMatchList, getLimitationMatchList, updateMatchLimitation, getMatchLimitDetails, exportMatches };
